import { ICardsMap, IDrawResultPoints } from 'widgets/DrawResult/types';

export enum ACTIONS {
  SAVE_DRAW_RESULT_TO_STORE = 'SAVE_DRAW_RESULT_TO_STORE',
  RESET_DRAW_RESULT_TO_STORE = 'RESET_DRAW_RESULT_TO_STORE',
}

export interface IDrawResultState {
  cards: ICardsMap;
  points: IDrawResultPoints;
}
